// Dates as the user's clock shows them (POS terminals run in India time).
// toISOString() is UTC, so between 00:00 and 05:30 IST it still says "yesterday".

// "YYYY-MM-DD" for today in the browser's timezone
export const todayLocal = () => new Date().toLocaleDateString("en-CA");

// Value for an <input type="datetime-local"> showing `date` in local time
export const toLocalInputValue = (date) => {
  const d = new Date(date);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

// A datetime-local value ("2026-10-08T18:00", no offset) as an exact ISO instant
export const localInputToISO = (value) => (value ? new Date(value).toISOString() : value);
